import { useMutation } from '@tanstack/react-query';

import { scoutClient } from '@/modules/scout-sourcing/scoutClient';
import type { ScoutConfirmResponse } from '@/modules/scout-sourcing/types';

type Payload = {
  jobId: string;
  jobSourcingId: string;
  maxCandidates?: number;
  acceptOutOfRangeMarket?: boolean;
};

export const useConfirmTargetingMutation = () =>
  useMutation<ScoutConfirmResponse, Error, Payload>({
    mutationFn: ({
      jobId,
      jobSourcingId,
      maxCandidates,
      acceptOutOfRangeMarket,
    }) =>
      scoutClient.confirm(
        jobId,
        jobSourcingId,
        maxCandidates,
        acceptOutOfRangeMarket,
      ),
  });
